import { render, staticRenderFns } from "./flowShipmentAct copy.vue?vue&type=template&id=11493a83&scoped=true&"
import script from "./flowShipmentAct copy.vue?vue&type=script&lang=js&"
export * from "./flowShipmentAct copy.vue?vue&type=script&lang=js&"
import style0 from "./flowShipmentAct copy.vue?vue&type=style&index=0&id=11493a83&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11493a83",
  null
  
)

export default component.exports